import { useBiogas } from 'services/api/queries';
import usePcrV2 from '../../hooks/usePcrV2';
import BiogasDataGridPdf from './BiogasDataGridPdf';

const BiogasDataListPdf = ({ epdVersionId, className }: { epdVersionId: string; className?: string }) => {
  const isPcrV2 = usePcrV2();
  const biogasDataList = useBiogas(epdVersionId).data;

  if (!isPcrV2 || !biogasDataList || biogasDataList.length === 0) {
    return null;
  }

  return biogasDataList.map((data, index) => <BiogasDataGridPdf className={className} key={index} data={data} />);
};

export default BiogasDataListPdf;
